// extracted by mini-css-extract-plugin
export default {"page":"List_page__j1pxp"};